import React, { forwardRef, useState } from 'react'
import DayFilteringWidget from '../student/DayFilteringWidget'
import CheckInWidget from '../student/CheckInWidget'
import DetailsOnEmotions from '../student/DetailsOnEmotions'
import WellbeingComparisonWidget from './WellbeingComparisonWidget'
import ReasonsForEmotions from '../student/ReasonsForEmotionsWidget'
import ParticipationWidget from '../student/ParticipationWidget'
import CounsellorAlertsWidget from './CounsellorAlertsWidget'
import { daysFilterList } from '../class/ClassAnalyticsWidgets'
import AnalyticsWidgetEvents from '../../../analytics/AnalyticsWidgetEvents'

const CounsellorAnalyticsWidgets = forwardRef(({ selectedOptions, daysFilter, setDaysFilter }, ref) => {
    return (
        <div ref={ref} className="flex-1 overflow-x-hidden px-2 pt-[20px]  overflow-y-auto">
            <AnalyticsWidgetEvents
                subjectId={JSON.stringify(selectedOptions)}
                widgets={[
                    { key: 'check-in', label: 'Check-in' },
                    { key: 'wellbeing-comparison', label: 'Wellbeing comparison' },
                    { key: 'emotion-details', label: 'Emotion details' },
                    { key: 'emotion-reasons', label: 'Reasons for emotions' },
                    { key: 'alerts', label: 'Alerts' },
                    { key: 'participation', label: 'Participation' },
                ]}
            />
            <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
            <div className="w-full h-[1px] bg-white mt-4"></div>
            <CheckInWidget daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="counsellor" />
            <WellbeingComparisonWidget daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="counsellor" />
            <DetailsOnEmotions daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="counsellor" />
            <ReasonsForEmotions daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="counsellor" />
            <CounsellorAlertsWidget daysFilter={daysFilter} isCounsellor selectedOptions={selectedOptions} selectedUsersScope={selectedOptions} />
            <ParticipationWidget daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} />
        </div>
    )
})

export default CounsellorAnalyticsWidgets
